import React, { Component } from 'react';
import { connect } from 'react-redux';
import * as actions from '../../../actions';
import { Radio } from 'antd';
import PropTypes from 'prop-types';

/**
 * @component
 * @name PriceHeaderTab
 * @category Search Page
 * @description It is the sort by cheaper/faster component
 * <br> <br>
 * **Example**
 * ```js
 *   <PriceHeaderTab />
 * ```
 */
class PriceHeaderTab extends Component {
  state = {
    hover: {
      borderColor: this.props.primaryColor,
      border: `1px solid ${this.props.primaryColor}`,
    },
    radioActiveCSS: {
      color: 'white',
      background: this.props.primaryColor,
    },
    radioInactiveCSS: {
      color: '#43637c',
    },
  };

  componentDidMount = () => {
    // console.log("loaded price header tab");
  };

  /**
   * @description It is invoked when sort by cheaper/faster radio group is changed
   * <br> <br>
   * **onPriceTabChange(e) -> {void}**
   * <br><br>
   * **Parameters:**
   * | Name          | Type          | Description  |
   * | :------------ |:------------- | :------------|
   * | e             | Event         | radio group onchange event  |
   * <br> <br>
   * Returns: Type: void
   */
  onPriceTabChange = (e) => {
    // console.log(e.target.value);
    //redux store filterByCheaper is updated in route-action,
    if (e.target.value === 'CHEAPER') {
      this.props.sortByCheaper();
    } else {
      this.props.sortByFaster();
    }
  };

  handleMouseEnter = (val) => {
    // console.log(val);
  };
  handleMouseLeave = (val) => {
    // console.log(val);
  };
  render() {
    const { filterByCheaper } = this.props;
    const { active, radioActiveCSS, radioInactiveCSS } = this.state;
    // console.log("PriceHeaderTab filterByCheaper: ", filterByCheaper);

    return (
      <div
        style={{
          width: '100%',
          marginBottom: '15px',
          height: '41px',
        }}
        className="my-radio-21a3741 testBla1"
      >
        {/* prettier-ignoree */}
        <Radio.Group
          style={{
            display: 'flex',
            flexFlow: 'row',
            justifyContent: 'center',
            alignItems: 'center',
          }}
          size="large"
          value={filterByCheaper ? 'CHEAPER' : 'FASTER'}
          buttonStyle="solid"
          onChange={this.onPriceTabChange}
        >
          <Radio.Button
            style={
              filterByCheaper ? { ...radioActiveCSS } : { ...radioInactiveCSS }
            }
            className="price-header-radio-btn-common"
            value="CHEAPER"
            onMouseEnter={() => this.handleMouseEnter('CHEAPER')}
            onMouseLeave={() => this.handleMouseLeave('CHEAPER')}
          >
            CHEAPER
          </Radio.Button>

          <Radio.Button
            style={
              filterByCheaper ? { ...radioInactiveCSS } : { ...radioActiveCSS }
            }
            value="FASTER"
            onMouseEnter={() => this.handleMouseEnter('FASTER')}
            onMouseLeave={() => this.handleMouseLeave('FASTER')}
            className="price-header-radio-btn-common"
          >
            FASTER
          </Radio.Button>
        </Radio.Group>
      </div>
    );
  }
}

PriceHeaderTab.propTypes = {
  /**
   * whether to sort rate cards by cheaper
   */
  filterByCheaper: PropTypes.bool,
  /**
   * primary color of web app
   */
  primaryColor: PropTypes.string,
  /**
   * secondary color of web app
   */
  secondaryColor: PropTypes.string,
};

const mapStateToProps = (state) => {
  return {
    filterByCheaper: state.route.filterByCheaper,
    primaryColor: state.code_config.primaryColor,
    secondaryColor: state.code_config.secondaryColor,
  };
};

export default connect(mapStateToProps, actions)(PriceHeaderTab);
